




















































































import {Component, Prop} from "vue-property-decorator";
import WarehouseTable from "@/modules/warehouses/shared/components/WarehouseTable/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {CustomerService} from "@/interfaces/entity/customerService";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";

@Component({
    name: "CustomerServiceExcel",
    components: {CommonStatusLabel, LadingStatusLabel, WarehouseTable}
})
export default class extends mixins(CommonMixin) {
    @Prop({required: true, type: Array}) readonly customerServices!: Array<CustomerService>;

    contactNames(contactNames) {
        return JSON.parse(contactNames)
    }
    contactPhones(contactPhones) {
        return JSON.parse(contactPhones)
    }
    contactEmails(contactEmails) {
        return JSON.parse(contactEmails)
    }
    adviseHistory(adviseHistory) {
        if (!adviseHistory) return '-'
        return  JSON.parse(adviseHistory)
    }
}
